import sileo from 'sileo';

const EmployeesList = new sileo.Model('hqzen', 'staff-employees-list');
const Department = new sileo.Model('hqzen', 'staff-department');
const TaskList = new sileo.Model('hqzen', 'task-list');
const TaskSummaryEmployeePayroll = new sileo.Model('hqzen', 'task-summary-employee-payroll');
const TimelogExports = new sileo.Model('hqzen', 'timelog-exports');
const JobSchedule = new sileo.Model('hqzen', 'staff-job-schedule');
const ChangeSchedule = new sileo.Model('timelogging', 'schedule-change', 'v4');
const StaffCounts = new sileo.Model('hqzen', 'staff-counts');

/**
 * @typedef {Object} StaffCountsResponse
 * @property {number} pending_issues_count - This is the total number of pending timelog issues
 * @property {number} accountabilities_count - This is the total number of
 * accountabilities of various employees
 * @property {number} admin_leave_count - This is the total number of admin leaves
 * @property {number} overtime_request_count - This is the total number of overtime requests
 * @property {number} sme_leave_request_count - This is the total number of sme leave requests
 * @property {number} incident_report_count - This is the total number of incident reports
 * @property {number} employee_count - This is the total number of employees
 * @property {number} separations_count - This is the total number of separations
 * @description This is the response object for the staff counts
 */

/**
 * @typedef {function({workforce_id: number}): Promise<StaffCountsResponse>} FetchStaffCountsAction
 */

const actions = {
    fetchDepartments(context, filters) {
        return Department.objects.filter(filters);
    },

    /**
     * @type {FetchStaffCountsAction}
     * @description This function fetches the various staff counts
    */
    fetchStaffCounts(_, filters) {
        return StaffCounts.objects.filter(filters);
    },

    fetchEmployeesList(context, filters) {
        return EmployeesList.objects.filter(filters);
    },

    fetchTasks(context, filters) {
        return TaskList.objects.filter(filters);
    },

    fetchTaskSummaryEmployeePayroll(_, filters) {
        // We're using filter here, although we need only a single instance,
        // we need to give filters in order to get the correct payroll.
        return TaskSummaryEmployeePayroll.objects.filter(filters);
    },

    fetchExports(context, filters) {
        return TimelogExports.objects.filter(filters);
    },

    getJobSchedule(context, filters) {
        // We're using filter here even though it only returns a single instance
        // because we need to pass filters such as employment_id, date, and region
        return JobSchedule.objects.filter(filters);
    },

    getScheduleChange(context, filters) {
        // We're using filter here even though it only returns a single instance
        // because we need to pass filters such as employment_id, date, and region
        return ChangeSchedule.objects.filter(filters).then(data => {
            return data[0];
        });
    },
};

export default {
    namespaced: true,
    actions,
};
